import Cookies from "js-cookie";

const formsAuthenticationCookieName = '.ASPXAUTH';

export function getAuthenticationTicket() {
	return Cookies.get(formsAuthenticationCookieName);
}

export function setAuthenticationTicket(ticket: string, options: Cookies.CookieAttributes) {
	Cookies.set(formsAuthenticationCookieName, ticket, options);
}
